import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { WorkspaceUser } from '../models/users';

export const UserManagementFetch = createAction('[UserManagement] Fetch', props<{ workspaceId: string }>());
export const UserManagementFetched = createAction('[UserManagement] Fetched', props<{ users: WorkspaceUser[] }>());
export const UserManagementError = createAction('[UserManagement] Error');

export const initialState: CommonApiState<WorkspaceUser[]> = {
  data: [],
  currentPedingApis: 0,
  isError: false
};

export const userManagementFeature = createFeature({
  name: 'userManagement',
  reducer: createReducer(
    initialState,
    on(UserManagementFetch, state => ({
      ...state,
      currentPedingApis: state.currentPedingApis + 1
    })),
    on(UserManagementFetched, (state, result) => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: false,
        data: result.users
      };
    }),
    on(UserManagementError, state => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: true
      };
    })
  ),
  extraSelectors: ({ selectUserManagementState }) => {
    const userManagementIsLoading = createSelector(
      selectUserManagementState,
      userManagementState => userManagementState.currentPedingApis > 0
    );

    //Don't let 2 or more action start another request
    const userManagementHasPendingRequest = createSelector(
      selectUserManagementState,
      userManagementState => userManagementState.currentPedingApis >= 2
    );

    return { userManagementIsLoading, userManagementHasPendingRequest };
  }
});
